import { useEffect, useRef } from 'react';

import { useSignUpContext } from '../context';
import { GTMEvent } from 'src/models/GoogleTagManager';
import { SubscriptionProduct } from '../../../models/SubscriptionProduct';
import { User } from '../../../models/User';
import GTMService, { PurchaseEventInfo } from 'src/services/GTMService';

export type { PurchaseEventInfo };

interface LegacyItemInfo {
  product: SubscriptionProduct;
  user?: User;
  discount_info?: string;
}

export const sendEcommerceEvent = (eventType: GTMEvent, itemInfo: LegacyItemInfo) => {
  GTMService.sendEvent({ ecommerce: null });
  GTMService.sendEvent({
    event: eventType,
    ecommerce: {
      items: [{
        item_id: itemInfo.product.id,
        item_name: itemInfo.product.name,
        price: itemInfo.product.price / 100,
      }],
      value: itemInfo.product.price / 100,
      currency: 'PLN',
      coupon: itemInfo.discount_info,
    },
  });
};

export const useTrackSignUpEvent = () => {
  const [{
    product,
    userDetails: { firstName, lastName, email },
    consents,
    paymentMethodProvided,
  }] = useSignUpContext();
  const shouldSendAddToCartEvent = useRef(true);
  const shouldSendBeginCheckoutEvent = useRef(true);

  useEffect(() => {
    if (product && shouldSendAddToCartEvent.current) {
      const userDetailsFilled = [firstName, lastName, email].every(Boolean);
      const allConsentsGranted = Object.values(consents).every(Boolean);
      if (userDetailsFilled && allConsentsGranted) {
        sendEcommerceEvent(GTMEvent.Registration, { product });
        shouldSendAddToCartEvent.current = false;
      }
    }
  }, [product, firstName, lastName, email, consents]);

  useEffect(() => {
    if (product && paymentMethodProvided && shouldSendBeginCheckoutEvent.current) {
      sendEcommerceEvent(GTMEvent.AddCardInfo, { product });
      shouldSendBeginCheckoutEvent.current = false;
    }
  }, [product, paymentMethodProvided]);
};
